import { useContext, useEffect, useRef, useState } from "react";
import { OnboardingContext } from "./OnboardingContext.tsx";
import QuestContext from "../../../../components/QuestWrapper.tsx";

import Header from "./Header.tsx";
import Content from "./Content.tsx";
import Footer from "./Footer.tsx";

import { OnboardingModularProps, OnboardingComponents } from "./types.ts";
import "../../../../components/Modules/css/input.css";

import General, { extractGradientColors, hexToGlassColor, useGeneral } from "../../../../general.ts";

import "../components/onboarding.css";

import {
  DEFAULT_BRAND_THEME,
  DEFAULT_QUEST_THEME,
} from "../components/tutorial.types";
import OnboardingApi, {
  UiPropsInterface,
} from "../components/OnboardingApi.ts";
import OnboardingThemeManager from "../components/themeManager.ts";
import config from "../../../../config.ts";
import Cookies from "universal-cookie";
import { ScreenHeadings } from "./types.ts";

// Onboarding Functions
import { metricApi, templateDesign } from "./OnboardingFunctions.ts";
import { FormData } from "../components/onboarding.types.ts";
import axios from "axios";
import OnboardingGetPropsFunctions from "./OnboardingGetPropsFunctions.ts";

const OnBoarding: React.FC<OnboardingModularProps> & OnboardingComponents = ({
  answer,
  getAnswers,
  questId: campaignId,
  setAnswer,

  controlBtnType,

  design = [],
  Headers = [],
  loadingTracker,
  multiChoice = "modal1",

  nextBtnText,
  onPageChange,
  progress,
  progressBarMultiLine,
  setLoading = () => {},
  singleChoose,
  styleConfig,
  template,
  token,
  uniqueEmailId,
  uniqueUserId,
  userId,
  variation,
  children,
  entityAuthenticationToken,
  ...props
}) => {
  const { apiKey, apiSecret, entityId, featureFlags, apiType, themeConfig, user } =
    useContext(QuestContext.Context);
  let BACKEND_URL =
    apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL;
  const onboardingApi = new OnboardingApi(apiType);
  const progressRef = useRef<HTMLDivElement>(null);

  let GeneralFunctions = new General("mixpanel", apiType);

  const cookies = new Cookies();
  const [uiProps, setUiProps] = useState<UiPropsInterface | undefined | null>(
    null
  );
  const [steps, setSteps] = useState<number[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [btnFlag, setButtonFlag] = useState<boolean>(false);
  const [formdata, setFormdata] = useState<FormData[] | []>([]);
  const [designState, setDesign] = useState(uiProps?.design || []);
  const [BrandTheme, setBrandTheme] = useState(DEFAULT_BRAND_THEME);
  const [campaignVariationId, setCampaignVariationId] = useState("");
  const [questThemeData, setQuestThemeData] = useState({
    ...DEFAULT_QUEST_THEME,
    accentColor: props.accent ? props.accent : DEFAULT_QUEST_THEME.accentColor,
  });
  const [validationData, setValidationData] = useState<DynamicBooleanObject>(
    {}
  );
  // const [multiChoiceModal, setMultiChoiceModal] = useState<"modal1" | "modal2">(multiChoice);
  const [headersArray, setHeadersArray] = useState<
    ScreenHeadings | ScreenHeadings[] | any
  >(Headers);
  // const [singleChooseModal, setSingleChooseModal] = useState<"modal1" | "modal2" | "modal3">(singleChoose || "modal1");
  const [questionTemplate, setQuestionTemplate] = useState<
    "multi-question" | "single-question" | "single-page"
  >(template || "single-page");
  const [showFooterApi, setShowFooterApi] = useState(true);
  interface DynamicBooleanObject {
    [key: string]: boolean;
  }

  const general = useGeneral('quest')


  const fetchCampaignData = async (headers: any) => {
    try {
      const response = await onboardingApi.fetchCampaignData(
        entityId,
        campaignId,
        headers,
        variation
      );

      if (response.sdkConfig?.uiProps?.questThemeData) {
        setQuestThemeData({
          ...response.sdkConfig.uiProps.questThemeData,
          accentColor: response.sdkConfig.uiProps.questThemeData.accentColor
            ? response.sdkConfig.uiProps.questThemeData.accentColor
            : props.accent,
        });
      
      }else if(props.accent){
        setQuestThemeData({...questThemeData, accentColor :props.accent})
      }

      if(response?.sdkConfig?.uiProps?.BrandTheme){
          setBrandTheme(response.sdkConfig.uiProps.BrandTheme.properties);
      }


      if (response?.sdkConfig?.uiProps?.showFooter !== undefined) {
        setShowFooterApi(response.sdkConfig.uiProps.showFooter);
      }

      setUiProps(response?.sdkConfig?.uiProps);

      if (response.actions) {
        const processedActions = onboardingApi.processActionsData(
          response.actions
        );
        setFormdata(processedActions);
        setCampaignVariationId(response.campaignVariationId);
      }
    } catch (error) {
      GeneralFunctions.captureSentryException(error);
    }
  };



  useEffect(() => {
    GeneralFunctions.fireTrackingEvent("quest_onboarding_loaded", "onboarding");
    general.trackEvent("quest-onboarding-loaded",
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId,
      true
    );
    const initialize = async () => {
      if (!entityId) return;

      try {
        const userAuth = await onboardingApi.getUserAuth({
          apiKey,
          entityId,
          uniqueUserId,
          uniqueEmailId,
          userId,
          token,
          entityAuthenticationToken
        });

        if (!userAuth) return;

        const headers = {
          apiKey,
          apiSecret,
          userId: userAuth.userId,
          token: userAuth.token,
        };

        const params = new URLSearchParams();
        params.set("platform", "REACT");
        if (variation) params.set("variation", variation);

        await fetchCampaignData(headers);

        // onboardingApi.metricApi(headers, BACKEND_URL, entityId, campaignId, campaignVariationId, { campaignVariationId: response.campaignVariationId }).view();
        onboardingApi
          .metricApi(
            headers,
            BACKEND_URL,
            entityId,
            campaignId,
            campaignVariationId,
            { campaignVariationId }
          )
          .view();

        // await fetchCampaignData(headers);
      } catch (error) {
        GeneralFunctions.captureSentryException(error);
      }
    };

    if (entityId) initialize();
  }, []);

  useEffect(() => {
    if (!formdata.length) return;

    let currentQuestions: any;
    if (questionTemplate === "multi-question") {
      currentQuestions = formdata.map((e, i) => {
        return i + 1;
      });
      let temp = formdata.map((e, i) => {
        if (designState[currentPage].includes(i + 1)) return i + 1;
      });
      let temp2 = temp.filter((e, i) => {
        if (designState[currentPage].includes(i + 1)) return true;
      });
      currentQuestions = temp2;
    } else if (questionTemplate === "single-question") {
      currentQuestions = [currentPage + 1];
    } else {
      let current = formdata.map((e, i) => {
        return i + 1;
      });
      currentQuestions = [...current];
    }

    let c = 0;
    for (let i = 0; i < currentQuestions.length; i++) {
      if (
        formdata[currentQuestions[i] - 1].required == false ||
        formdata[currentQuestions[i] - 1].type == "LINK_OPEN_READ"
      ) {
        c++;
      } else {
        if (
          !!answer[formdata[currentQuestions[i] - 1].actionId] &&
          answer[formdata[currentQuestions[i] - 1].actionId].length > 0
        ) {
          c++;
        }
      }
    }

    if (currentQuestions.length > 0 && c == currentQuestions.length) {
      setButtonFlag(true);
    } else {
      setButtonFlag(false);
    }
  }, [answer, formdata, currentPage]);

  useEffect(() => {
    let questUserId = cookies.get("questUserId");
    let questUserToken = cookies.get("questUserToken");

    let headers = {
      apikey: apiKey,
      apisecret: apiSecret,
      userId: questUserId ? questUserId : userId,
      token: questUserToken ? questUserToken : token,
    };

    if (currentPage > 0 && currentPage < designState?.length) {
      // metricApi(headers).page(currentPage);
      metricApi(
        headers,
        BACKEND_URL,
        entityId,
        campaignId,
        campaignVariationId
      ).page(currentPage);
    }

    onPageChange?.(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (btnFlag == true) {
      setSteps([...steps, currentPage]);
    } else {
      if (steps.includes(currentPage)) {
        const updatedSteps = steps.filter((step) => step !== currentPage);
        setSteps(updatedSteps);
      }
    }
  }, [btnFlag, currentPage]);

  const handleUpdate = (e: any, id: string, j: string) => {
    if (e.target.checked == true && j == "check") {
      let ans = answer[id] || [];
      ans.push(e.target.value);
      setAnswer({
        ...answer,
        [id]: ans,
      });
    } else if (
      e.target.checked == false &&
      typeof answer[id] == "object" &&
      j == "check"
    ) {
      let ans = answer[id];
      let mod_ans = ans.filter((an: string | number) => an != e.target.value);
      setAnswer({
        ...answer,
        [id]: mod_ans,
      });
    } else {
      setAnswer({
        ...answer,
        [id]: e.target.value,
      });
    }
  };

  const [wd, setWd] = useState(0);

  const ProgressBar = () => {
    useEffect(() => {
      if (!!progressRef.current && progressRef.current.clientWidth != wd) {
        setWd(progressRef?.current?.clientWidth);
      }
    }, []);
    return (
      <div className="q-onb-progress">
        <div
          style={{
            gridTemplateColumns: progress
              ? `repeat(${progress.length}, 1fr)`
              : "",
          }}
          ref={progressRef}
        >
          {!!progress &&
            (!!design || !!uiProps?.design) &&
            (progress.length == design?.length ||
              progress.length == uiProps?.design?.length) &&
            progress.map((prog: string, i: number) => (
              <div key={i}>
                {steps.includes(i) == true ? (
                  <div
                    className="q-onb-progress-comp"
                    style={{
                      borderColor: themeManager.getProgressBarBorderStyles(),
                    }}
                  >
                    <div
                      style={{
                        maxWidth: `${
                          (wd - (progress.length - 1) * 15) / progress.length -
                          32
                        }px`,
                        whiteSpace: progressBarMultiLine ? "normal" : "nowrap",
                        overflow: progressBarMultiLine ? "" : "hidden",
                        textOverflow: progressBarMultiLine ? "" : "ellipsis",
                        color: themeManager.getProgressBarStyles()?.includes("gradient") ? extractGradientColors(
                          themeManager.getProgressBarStyles()
                        ) : themeManager.getProgressBarStyles(),
                      }}
                    >
                      {prog}
                    </div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <path
                        opacity="0.3"
                        d="M10.8333 18.3333C15.4357 18.3333 19.1667 14.6023 19.1667 9.99996C19.1667 5.39759 15.4357 1.66663 10.8333 1.66663C6.23095 1.66663 2.49999 5.39759 2.49999 9.99996C2.49999 14.6023 6.23095 18.3333 10.8333 18.3333Z"
                        fill={
                          hexToGlassColor(BrandTheme?.primaryColor || questThemeData?.accentColor || props?.accent || BrandTheme?.accentColor || "#098849",0.5)
                        }
                      />
                      <path
                        d="M14.8074 6.51474C15.1215 6.17828 15.6488 6.1601 15.9853 6.47412C16.3217 6.78815 16.3399 7.31548 16.0259 7.65193L10.1925 13.9019C9.88787 14.2284 9.38003 14.2566 9.041 13.9661L6.12434 11.4661C5.7749 11.1665 5.73443 10.6404 6.03395 10.291C6.33347 9.94157 6.85955 9.9011 7.20899 10.2006L9.51916 12.1808L14.8074 6.51474Z"
                        fill={extractGradientColors(themeManager.getCheckBoxColor())}
                      />
                    </svg>
                  </div>
                ) : i == currentPage ? (
                  <div
                    className="q-onb-progress-comp"
                    style={{
                      borderColor: themeManager.getProgressBarCurrentTabColor(),
                    }}
                  >
                    <div
                      style={{
                        maxWidth: `${
                          (wd - (progress.length - 1) * 15) / progress.length -
                          32
                        }px`,
                        whiteSpace: progressBarMultiLine ? "normal" : "nowrap",
                        overflow: progressBarMultiLine ? "" : "hidden",
                        textOverflow: progressBarMultiLine ? "" : "ellipsis",
                        color: themeManager.getProgressBarCurrentTabColor(),
                      }}
                    >
                      {prog}
                    </div>
                  </div>
                ) : (
                  <div
                    className="q-onb-progress-comp"
                    style={{
                      borderColor: themeManager.getProgressBarPendingTabColor(),
                    }}
                  >
                    <div
                      style={{
                        maxWidth: `${
                          (wd - (progress.length - 1) * 15) / progress.length -
                          32
                        }px`,
                        whiteSpace: progressBarMultiLine ? "normal" : "nowrap",
                        overflow: progressBarMultiLine ? "" : "hidden",
                        textOverflow: progressBarMultiLine ? "" : "ellipsis",
                        color: themeManager.getProgressBarPendingTabColor(),
                      }}
                    >
                      {prog}
                    </div>
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
    );
  };

  const validateInputRegex = (validation: boolean, actionId: string) => {
    setValidationData((prev) => {
      return {
        ...prev,
        [actionId]: validation,
      };
    });
  };

  const checkValidationValues = () => {
    let count = 0;
    const data = Object.keys(validationData).map((value) => {
      if (validationData[value]) {
        count = count + 1;
      } else {
        return true;
      }
    });
    if (count === Object.keys(validationData).length) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (uiProps?.BrandTheme && Object.keys(uiProps?.BrandTheme).length > 0) {
      setBrandTheme(uiProps?.BrandTheme?.properties || BrandTheme);
    }
    if (
      uiProps?.questThemeData &&
      Object.keys(uiProps?.questThemeData).length > 0
    ) {
      // setQuestThemeData({uiProps?.questThemeData});
    }

    if (headersArray?.length === 0) {
      setHeadersArray(Headers?.length == 0 ? uiProps?.Headers : Headers);
    }

    setQuestionTemplate(template || uiProps?.template || "single-page");
  }, [uiProps]);

  function returnAnswers() {
    GeneralFunctions.fireTrackingEvent(
      "quest_onboarding_submit_btn_clicked",
      "onboarding"
    );

    if (currentPage < designState.length - 1) {
      setCurrentPage((prev) => prev + 1);
    } else {
      let crt: any = { ...answer };
      for (let i of Object.keys(crt)) {
        if (i.includes("/manual") && crt[i] != "") {
          let id: string = i.split("/manual")[0];
          let criteriaDetails: FormData[] = formdata.filter(
            (item) => item.actionId == id
          );
          if (criteriaDetails[0].manualInput == crt[id]) {
            crt[id] = crt[i];
          }
        }
      }

      let actions = Object.keys(crt)
        .filter((key: string) => !key.includes("/manual"))
        .map((key: string) => ({
          actionId: key,
          answers: typeof crt[key] === "object" ? crt[key] : [crt[key]],
        }));

      let questUserId = cookies.get("questUserId");
      let questUserToken = cookies.get("questUserToken");
      let externalUserId = cookies.get("externalUserId");

      let headers = {
        apikey: apiKey,
        apisecret: apiSecret,
        userId:
          !!externalUserId &&
          !!questUserId &&
          !!questUserToken &&
          externalUserId == uniqueUserId
            ? questUserId
            : userId,
        token:
          !!externalUserId &&
          !!questUserId &&
          !!questUserToken &&
          externalUserId == uniqueUserId
            ? questUserToken
            : token,
      };

      getAnswers && getAnswers(crt);

      try {
        axios.post(
          `${BACKEND_URL}api/v2/entities/${entityId}/campaigns/${campaignId}/verify`,
          { actions, campaignVariationId },
          { headers }
        );

        general.trackEvent("quest-onboarding-submitted",
          (uniqueUserId || userId || user.userId)!,
          {},
          true,
          !uniqueUserId
        );

      } catch (error) {
        GeneralFunctions.captureSentryException(error);
      }

      try {
        metricApi(
          headers,
          BACKEND_URL,
          entityId,
          campaignId,
          campaignVariationId
        ).complete();
      } catch (error) {
        GeneralFunctions.captureSentryException(error);
      }
    }
  }

  if (
    featureFlags[config.FLAG_CONSTRAINTS.OnboardingFlag]?.isEnabled == false
  ) {
    return <div></div>;
  }

  // from here
  const themeManager = new OnboardingThemeManager(
    themeConfig,
    styleConfig || uiProps?.styleConfig,
    questThemeData,
    BrandTheme
  );

  let onboardingGetPropsFunctions;
  onboardingGetPropsFunctions = new OnboardingGetPropsFunctions(
    controlBtnType || uiProps?.controlBtnType,
    design.length == 0 ? uiProps?.design : design,
    Headers.length == 0 ? uiProps?.Headers : Headers,
    loadingTracker || uiProps?.loadingTracker,
    multiChoice || uiProps?.multiChoice,
    nextBtnText || uiProps?.nextBtnText,
    progress || uiProps?.progress,
    progressBarMultiLine || uiProps?.progressBarMultiLine,
    uiProps?.showFooter,
    singleChoose || uiProps?.singleChoose,
    template || uiProps?.template
  );

  useEffect(() => {
    templateDesign({
      template: onboardingGetPropsFunctions.getTemplate(),
      design: onboardingGetPropsFunctions?.getDesign(),
      setDesign,
      formdata,
    });
  }, [uiProps, formdata]);

  const contextValue = {
    formdata,
    headersArray,
    currentPage,
    setCurrentPage,

    design,
    designState,
    progress,
    progressBarMultiLine,
    ProgressBar,

    template,
    singleChoose,
    multiChoice,
    answer,

    controlBtnType,
    uiProps,
    nextBtnText,
    campaignId,
    btnFlag,
    returnAnswers,

    handleUpdate,
    validateInputRegex,
    checkValidationValues,
    themeManager,

    validationData,
    campaignVariationId,
    apiSecret,
    uniqueUserId,
    userId,
    token,
    getAnswers,
    BACKEND_URL,
    onPageChange,
    questionTemplate,
    setAnswer,
    onboardingGetPropsFunctions,
    showFooter: showFooterApi,
  };

  return (
    <OnboardingContext.Provider value={contextValue}>
      {formdata.length > 0 && (
        <div
          className="q-onb-home"
          style={themeManager.getContainerStyles()}
          {...props}
        >
          <div className="q-onb-ch">
            {children || (
              <>
                <Header />
                <Content />
                <Footer />
              </>
            )}
          </div>
        </div>
      )}
    </OnboardingContext.Provider>
  );
};

OnBoarding.Header = Header;
OnBoarding.Content = Content;
OnBoarding.Footer = Footer;

export default OnBoarding;
